// reservation-guest-modal.component.ts
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { data } from 'aws-cdk';


@Component({
  selector: 'app-reservation-guest-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './reservation-guest-modal.component.html',
  styleUrl: './reservation-guest-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class ReservationGuestModalComponent {
  guests: any[] = [];
  totalGuests: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ReservationGuestModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.totalGuests = data.length;
  }

  ngOnInit(): void {
    this.guests = this.data;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}